import React from 'react';
import { Billboard } from '@companycam/slab-web';
import styled from 'styled-components';

import { translate } from 'translations/i18n';

const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
`;

type ErrorBoundaryFallbackProps = {
  clearError: () => void;
};

const ErrorBoundaryFallback = ({ clearError }: ErrorBoundaryFallbackProps) => {
  return (
    <Container>
      <Billboard
        title={translate('core.errorBoundaryFallback.heading')}
        color="destroy"
        iconName="alert-circle"
        secondaryAction={{
          label: translate('core.errorResetButton.message'),
          onClick: clearError,
        }}
        message={translate('core.errorBoundaryFallback.message')}
      />
    </Container>
  );
};

export default ErrorBoundaryFallback;
